import React, { useEffect } from 'react';
import '../styles/Notification.css';

function Notification({ message, type, onClose, duration = 5000 }) {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  return (
    <div className={`notification notification-${type}`}>
      <div className="notification-content">
        <span className="notification-icon">
          {type === 'success' && <i className="bi bi-check-circle-fill"></i>}
          {type === 'error' && <i className="bi bi-x-circle-fill"></i>}
          {type === 'info' && <i className="bi bi-info-circle-fill"></i>}
        </span>
        <span className="notification-message">{message}</span>
        <button className="notification-close" onClick={onClose}><i className="bi bi-x-lg"></i></button>
      </div>
    </div>
  );
}

export default Notification;
